import {
  Flex,
  HStack,
  type PlacementWithLogical,
  Stack,
  Text,
} from '@chakra-ui/react';
import { IconFilter1 as FunnelIcon } from 'central-icons/IconFilter1';
import { forwardRef } from 'react';

import { TourClasses } from '@revelio/core';
import { Button } from '@revelio/ui';

import styles from './FilterMenu.module.css';
import { FilterPopover } from './FilterPopover';
import { FILTER_MENU_TRIGGER_TESTID } from './filter-menu-testid';

interface FilterButtonProps {
  isDisabled?: boolean;
}

const FilterButton = forwardRef<HTMLButtonElement, FilterButtonProps>(
  ({ isDisabled, ...props }, ref) => {
    return (
      <Button
        {...props}
        ref={ref}
        variant="link"
        disabled={isDisabled}
        className={styles.filterButton}
        size="sm"
        data-testid={FILTER_MENU_TRIGGER_TESTID}
      >
        <HStack spacing={1}>
          <FunnelIcon stroke="1.5" size="16px" />
          <Text fontSize="13px">Filter</Text>
        </HStack>
      </Button>
    );
  }
);

interface FilterMenuProps {
  isDisabled?: boolean;
  popoverPlacement?: PlacementWithLogical;
  shiftLeft?: boolean;
}

export const FilterMenu = ({
  isDisabled = false,
  popoverPlacement = 'bottom-start',
  shiftLeft = false,
}: FilterMenuProps) => {
  return (
    <Flex
      wrap="wrap"
      fontSize="sm"
      rowGap={2.5}
      alignItems="center"
      className={TourClasses.TOUR_FILTER_MENU_CLASS}
      {...(shiftLeft && { marginLeft: '-0.5rem' })}
    >
      <Stack direction="row">
        <Flex alignItems="center" gap="1px">
          <FilterPopover
            trigger={<FilterButton isDisabled={isDisabled} />}
            placement={popoverPlacement}
          />
        </Flex>
      </Stack>
    </Flex>
  );
};
